import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '../../_services';
//import { DataManager, WebApiAdaptor, Query } from '@syncfusion/ej2-data';
//import { config } from '../../_helpers'

/* async function datos(p_opcion) {
    const datos = await new DataManager({ url: config.HostUrl + p_opcion + '/', 
                adaptor: new WebApiAdaptor(),
                headers:[{ "Content-Type":  "application / json",
                            "api-token": `${authenticationService.currentUserValue.jwt_token}`   
                        }],
                crossDomain: true}).executeQuery(new Query().page(1,5000))
                .then((resp) => {
                    console.log('respuesta 1')
                    console.log(resp);
                    console.log(new Date())
                    return resp.result.orden_servicio;
                })  ; 
    
    return datos; 
} */

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => {
        const currentUser = authenticationService.currentUserValue;
        if (!currentUser) {
            // not logged in so redirect to login page with the return url
            //window.location.reload();
            return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        }

        // authorised so return component
        return <Component {...props} />
    }} />
)

export const PrivateRouteRender = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => {
        const currentUser = authenticationService.currentUserValue;

        if (!currentUser) {
            // not logged in so redirect to login page with the return url
            return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        }
        /* rest.dataSourceSettings.dataSource = datos(rest.opcion);
        rest.arch_json = true; */
        // authorised so return component
        return <Component {...rest} />
    }} />
)